import { FBCourseStats, FBStepStats } from "JS/Models/Firebase/Courses";
import { courseFirebaseService } from "./CourseService";
import { bootstrapFirebaseService } from "JS/Helpers";
import { Unsubscribe } from "firebase/database";

export const observeStepStats = (
    courseSkuId: string,
    stepSkuId: string,
    onObserve: (stats: FBStepStats) => void,
): Promise<Unsubscribe | undefined> => {
    bootstrapFirebaseService();
    return courseFirebaseService.observeStepStats(
        courseSkuId,
        stepSkuId,
        onObserve,
    );
};

export const observeCourseStats = (
    sku: string,
    onObserve: (stats: FBCourseStats) => void,
): Promise<Unsubscribe | undefined> => {
    bootstrapFirebaseService();
    return courseFirebaseService.observeCourseStats(sku, onObserve);
};
